'use client'

import { Carousel, CarouselApi, CarouselContent, CarouselItem, CarouselOptions } from '@repo/ui/components/carousel'
import { cn } from '@repo/ui/lib/utils'
import { useMotionValueEvent, useScroll } from 'motion/react'
import { CSSProperties, FunctionComponent, ReactNode, useState } from 'react'
import { PageSectionProps } from '../../../types/page.types'

interface Props extends PageSectionProps<'sectionBanner'> {
  bannerItems: ReactNode[]
}

const SectionBanner: FunctionComponent<Props> = ({ index, section, bannerItems }) => {
  const { scrollYProgress } = useScroll()
  const [api, setApi] = useState<CarouselApi>()
  const items = section?.items || []
  const itemCount = items.length

  // Translate vertical page scroll into horizontal carousel scroll.
  useMotionValueEvent(scrollYProgress, 'change', (current) => {
    if (section.carouselScrollAnimation) {
      // Ensure we have something to scroll.
      if (((section.stackedOnMobile && window.innerWidth >= 1024) || !section.stackedOnMobile) && (api?.scrollSnapList() || []).length > 1) {
        const difference = current - (scrollYProgress?.getPrevious() || 0)
        const direction = difference > 0 ? 'down' : 'up'

        api?.internalEngine()?.scrollTo?.distance(current * 8 * (direction === 'up' ? 1 : -1), false)
      }
    }
  })

  const opts: CarouselOptions = {
    loop: section.carouselLoop,
  }

  if (itemCount === 0) {
    return null
  }

  return (
    <div data-index={index} data-type={section._type}>
      {section.stackedOnMobile && <div className='flex w-full flex-col lg:hidden'>{bannerItems}</div>}
      <Carousel
        setApi={setApi}
        opts={opts}
        className={cn('bg-[var(--bg,_black)]', section.stackedOnMobile && 'hidden lg:block')}
        style={{ '--item-count': itemCount, '--bg': section.carouselBackgroundColor || '' } as CSSProperties}
      >
        <CarouselContent>
          {bannerItems.map((bannerItem, i) => (
            <CarouselItem key={i} className='aspect-[2/3] w-full lg:w-auto lg:basis-[35rem] 2xl:basis-[50rem]'>
              {bannerItem}
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  )
}

export default SectionBanner
